import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

interface CompanyDetailProps {
  id: number;
  onUpdateCompleted?: (id: string | undefined ) => void;
}

const useCompanyDetail = ({id, onUpdateCompleted}:CompanyDetailProps) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [companyInfo, setCompanyInfo] = useState<CompanyListDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  
  const { isLoading } = useQuery(
    [endpoints.company.info, {id: id}],
    () =>
      fetcher.company.postCompanyInfo({id: id}),
    {
      onSuccess: (res: CompanyInfoResDto) => {
        switch (res.code) {
          case 200:
            setCompanyInfo(res.result?.info);
            break;
          default:
            break;
        }
      },
    },
  );

  const { mutate: companyInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.company.add],
    fetcher.company.postCompanyAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            onUpdateCompleted?.(res.result?.id);
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.");
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: companyUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.company.update],
    fetcher.company.postCompanyUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            onUpdateCompleted?.(id.toString());
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.");
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )


  return { isLoading, companyInfo, companyInsert, companyUpdate, insertSuccess, updateSuccess };
};

export default useCompanyDetail;
